<template>
    <rkm-area
        type="fieldset"
        title="Temas para saúde"
        v-if="showTema"
    >

        <rkm-row>
            <rkm-col>
                <rkm-form-group>
                    <rkm-form-checkbox-group
                        v-model="data.model.saudeTemas"
                        name="Temas para saúde"
                        :validations="validations.tema"
                    >
                        <rkm-row>
                            <rkm-col
                                v-for="item in data.form.saudeTemas"
                                v-bind:key="item.id"
                                cols="6"
                            >
                                <rkm-form-checkbox
                                    :value="item.id"
                                    class="text-nowrap"
                                    inline
                                >
                                    {{ item.descricao }}
                                </rkm-form-checkbox>
                            </rkm-col>
                        </rkm-row>
                    </rkm-form-checkbox-group>
                </rkm-form-group>
            </rkm-col>
        </rkm-row>

    </rkm-area>
</template>

<script>

//Enums
import atividadeTipo from '@/enums/atencao-basica/atividade-coletiva/atividadeTipo'

export default {
    data: () => ({
        enums: {
            atividadeTipo
        },
    }),
    computed: {
        showTema() {
            const atividadeTipoId = this.data.model.atividade.atividadeTipoId

            const tiposAtividade = [
                this.enums.atividadeTipo.EDUCACAO_EM_SAUDE,
                this.enums.atividadeTipo.ATENDIMENTO_EM_GRUPO,
                this.enums.atividadeTipo.AVALIACAO_PROCEDIMENTO_COLETIVO,
                this.enums.atividadeTipo.MOBILIZACAO_SOCIAL
            ]

            return this.data.model.saudeTemas && tiposAtividade.includes(atividadeTipoId)

        },
        validations() {
            return {
                tema: {
                    required: this.isRequiredTema
                }
            }
        },
        isRequiredTema() {
            const tiposAtividade = [
                this.enums.atividadeTipo.EDUCACAO_EM_SAUDE,
                this.enums.atividadeTipo.ATENDIMENTO_EM_GRUPO,
                this.enums.atividadeTipo.AVALIACAO_PROCEDIMENTO_COLETIVO
            ]

            return tiposAtividade.includes(this.data.model.atividade.atividadeTipoId)
        }
    },
    watch: {
        'data.model.atividade.atividadeTipoId': function (atividade) {

            const atividadeTipoId = atividade

            const tiposAtividade = [
                this.enums.atividadeTipo.EDUCACAO_EM_SAUDE,
                this.enums.atividadeTipo.ATENDIMENTO_EM_GRUPO,
                this.enums.atividadeTipo.AVALIACAO_PROCEDIMENTO_COLETIVO,
                this.enums.atividadeTipo.MOBILIZACAO_SOCIAL
            ]

            if (!tiposAtividade.includes(atividadeTipoId)) {
                this.data.model.saudeTemas = []
            }

        },
    },
    props: {
        data: { type: Object, required: false, },
    }
}
</script>